import { Box, Spinner, Text } from '@lego/klik-ui';
import { useWorkspaceNetworkConfig } from '@/hooks/workspace';

type Props = {
  workspaceId: number;
  networkConfigId: number;
};

const StatusMessage = ({ message }: { message: string }) => (
  <Box background="white" p={4}>
    <Text color="red.600">{message}</Text>
  </Box>
);

export const NetworkConfigContent = ({ workspaceId, networkConfigId }: Props) => {
  const { data, error, isLoading } = useWorkspaceNetworkConfig(workspaceId, networkConfigId);
  const config = data;

  if (isLoading) {
    return (
      <Box background="white" p={4}>
        <Spinner margin="auto" size="sm" />
      </Box>
    );
  }

  if (error) return <StatusMessage message="Failed to load network config" />;
  if (!config) return <StatusMessage message="Network config not found" />;

  const fileContents = atob(config.fileContents);

  return (
    <Box background="white" p={4}>
      <Text
        background="#f1f1f1"
        borderRadius="md"
        boxShadow="inner"
        fontFamily="mono"
        fontSize="sm"
        p={4}
        whiteSpace="pre-wrap"
        wordBreak="break-all"
      >
        {fileContents}
      </Text>
    </Box>
  );
};
